import { home } from "./home";
import { login } from "./login";
import { gamemanage } from "./game/manage";
import { gamenews } from "./game/news";
import { gamerecommend } from "./game/recommend";
import { idoProject } from "./ido/project";
import { idostation } from "./ido/station";
import { idoRecommend } from "./ido/recommend";
import { nftProject } from "./nft/project";
import { nftStation } from "./nft/station";
import { nftRecommend } from "./nft/recommend";
import { setting } from "./setting";
import { token } from "./token";
import { senum } from "./setting/senum";
import { staff } from "./setting/staff";
import { settingHelp } from "./feeds/help";
import { settingBanner } from "./setting/banner";
import { settingRole } from "./setting/role";
import { dailyNews } from "./feeds/dailyNews";
import { marketingSubSend } from "./marketing/subsend";
import { marketingMember } from "./marketing/member";
import { marketingFeedback } from "./marketing/feedback";
import { marketingSubscribe } from "./marketing/subscribe";
import { missionManage } from "./mission/manage";
import { missionMedal } from "./mission/medal";
import { missionAvatarFrame } from "./mission/avatarFrame";
import { marketingMarkForm } from "./marketing/markform";
import { settingStaffLog } from "./setting/staffLog"
import { StatsList} from "./StatsList"
import { HotWords} from "./hotword";
import { feedsRecommend } from "./feeds/recommend";
import { settingApi } from "./setting/api"
import { inoProject } from "./ino/project";
import { inoStation } from "./ino/station";
import { inoRecommend } from "./ino/recommend";
import { communityIssue } from "./community/issue";
import { communityCategory } from "./community/category";
import { communityPost } from "./community/post";
import { communityTag } from "./community/tag";
import { communityReport } from "./community/report";
import { communityTopic } from "./community/topic";
import { communityRecommend } from "./community/recommend";
import { communityCommunity } from "./community/community";
import { communityMessage } from "./community/message";
import { settingIP } from "./setting/IP";
import {Layout } from "./layout"
export default {
  ...home,
  ...login,
  ...gamemanage,
  ...gamenews,
  ...gamerecommend,
  ...idoProject,
  ...idostation,
  ...idoRecommend,
  ...nftProject,
  ...nftStation,
  ...nftRecommend,
  ...setting,
  ...senum,
  ...token,
  ...staff,
  ...settingHelp,
  ...settingBanner,
  ...dailyNews,
  ...marketingSubSend,
  ...marketingMember,
  ...marketingFeedback,
  ...marketingSubscribe,
  ...marketingMarkForm,
  ...missionManage,
  ...missionMedal,
  ...missionAvatarFrame,
  ...settingRole,
  ...settingStaffLog,
  ...StatsList,
  ...HotWords,
  ...feedsRecommend,
  ...settingApi,
  ...inoProject,
  ...inoStation,
  ...inoRecommend,
  ...communityIssue,
  ...communityCategory,
  ...communityTag,
  ...communityPost,
  ...communityReport,
  ...communityTopic,
  ...communityRecommend,
  ...communityCommunity,
  ...communityMessage,
  ...settingIP,
  ...Layout,
};
